import React from "react";
import { useT } from "@/lib/LanguageContext";
import { OFFSET_UNITS, OFFSET_UNIT_KEYS, OFFSET_ANCHOR_KEYS } from "../../contract";
import CrmInput from "../../ui/CrmInput";
import CrmSelect from "../../ui/CrmSelect";
import { LABEL } from "../../ui/classes";
import { CRM } from "../../../../constants/testIds/crm";

/**
 * A step's delay (spec: "24" · "hours before session ▾"): a number plus ONE combined
 * unit+anchor dropdown, as the wireframe draws it. `anchors` is the set this sequence's
 * trigger allows — every trigger accepts "after trigger"; only `booking_exists`
 * (reminders) also offers "before session".
 */
export default function OffsetField({ offset, onChange, anchors, stepIndex }) {
  const t = useT("crm");
  const combo = (unit, anchor) => `${unit}:${anchor}`;
  const [unit, anchor] = (offset ? combo(offset.unit, offset.anchor) : combo("hours", anchors[0])).split(":");

  const options = anchors.flatMap((a) => OFFSET_UNITS.map((u) => ({
    value: combo(u, a),
    label: `${t(OFFSET_UNIT_KEYS[u])} ${t(OFFSET_ANCHOR_KEYS[a])}`,
  })));

  return (
    <div className="flex flex-wrap items-end gap-3">
      <div>
        <label htmlFor={`crm-seq-step-${stepIndex}-offset-value`} className={LABEL}>{t("seq.offsetValueLabel")}</label>
        <CrmInput id={`crm-seq-step-${stepIndex}-offset-value`} type="number" min={1} value={offset?.value ?? ""}
          onChange={(e) => onChange({ ...offset, value: Number(e.target.value) })}
          data-testid={CRM.seqStepOffsetValue(stepIndex)} className="w-20" />
      </div>
      <div>
        <label htmlFor={`crm-seq-step-${stepIndex}-offset-unit`} className={LABEL}>{t("seq.offsetUnitAnchorLabel")}</label>
        <CrmSelect id={`crm-seq-step-${stepIndex}-offset-unit`} value={combo(unit, anchor)}
          onChange={(e) => { const [u, a] = e.target.value.split(":"); onChange({ ...offset, unit: u, anchor: a }); }}
          options={options} data-testid={CRM.seqStepOffsetUnit(stepIndex)} />
      </div>
    </div>
  );
}
